import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import { connectWallet } from "@/utils/index.js";

Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    isLand: "zh",
    address: "",
    token: "",
    inviteCode: "",
    userId: null,
    // 是否是全屏
    fullScreen: false,
    // 登录状态
    isLoginState: false,
    show: false,
    nonce: "",
  },
  mutations: {
    SET_ISLOGINSTATE(state, str) {
      state.isLoginState = str;
    },
    SET_FULLSCREEN(state, str) {
      state.fullScreen = str;
    },
    SET_ISLANGD(state, str) {
      state.isLand = str;
    },
    SET_TOKEN(state, str) {
      state.token = str;
    },
    SET_ADDRESS(state, str) {
      state.address = str;
    },
    SET_ClEAR(state, str) {
      state.token = "";
      state.isLoginState = false;
      state.nonce = "";
      state.show = false;
      state.userId = null;
    },
    SET_USERID(state, str) {
      state.userId = str;
    },
    SET_INVITECODE(state, str) {
      state.inviteCode = str;
    },
    SET_NONCE(state, str) {
      state.nonce = str;
    },
    SET_SHOW(state, str) {
      state.show = str;
    },
  },
  actions: {
    async clearAuthData({ commit }) {
      commit("SET_ClEAR");
      sessionStorage.removeItem("token");
    },
    async loginStore({ commit }) {
      try {
        const address = await connectWallet();
        commit("SET_ADDRESS", address);
        return address;
      } catch (error) {
        Vue.prototype.$toast(error);
        throw error;
      }
    },
  },
  plugins: [
    createPersistedState({
      key: "config_date",
      paths: [
        "isLand",
        "token",
        "address",
        "inviteCode",
        "userId",
        "fullScreen",
        "isLoginState",
        "show",
      ],
    }),
  ],
});
export default store;
